import {Blockquote} from "@mantine/core";
import React from "react";

export function ProcessorCardBody({body}: { body: string }) {
    return (
        <div className="card-body">
            <Blockquote>
                {body}
            </Blockquote>
        </div>
    )
}
